import { UnifiedUpload } from "@/shared/ui/UnifiedUpload";
import { toast } from "@/shared/hooks/use-toast";

interface CoverUploadProps {
  coverPreview: string | null;
  onCoverChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveCover: () => void;
  error?: boolean;
  errorMessage?: string;
  title: string;
  onClearError?: () => void;
  disabled?: boolean;
}

export const CoverUpload = ({
  coverPreview,
  onCoverChange,
  onRemoveCover,
  error = false,
  errorMessage,
  title,
  onClearError,
  disabled = false,
}: CoverUploadProps) => {
  const handleCoverChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onClearError?.();
    onCoverChange(e);
  };

  return (
    <UnifiedUpload
      id="cover"
      title={title}
      preview={coverPreview}
      onFileChange={handleCoverChange}
      onRemove={onRemoveCover}
      acceptTypes="image/*"
      error={error}
      errorMessage={errorMessage}
      variant="cover"
      enableDragDrop={true}
      maxSizeMB={0.5}
      disabled={disabled}
      onError={(error) => toast({
        title: "Erro",
        description: error,
        variant: "destructive",
      })}
    />
  );
};
